export const SLIDES_PER_VIEW = 3;
export const SLIDES_PER_VIEW_MOBILE = 1;
export const SLIDES_SPACE_BETWEEN = 48;
export const SLIDE_DELAY = 6000;
export const PAGINATION_CLASS_NAME = "swiper-pagination";
export const NAVIGATION_NEXT_CLASS_NAME_SERVICES = "swiper-navigation-services-next";
export const NAVIGATION_PREV_CLASS_NAME_SERVICES = "swiper-navigation-services-prev";
